import { Instance } from 'mobx-state-tree';
import { VisitScheduledDtoModelBase } from './VisitScheduledDtoModel.base';

/* The TypeScript type of an instance of VisitScheduledDtoModel */
export interface VisitScheduledDtoModelType extends Instance<typeof VisitScheduledDtoModel.Type> {}

/* A graphql query fragment builders for VisitScheduledDtoModel */
export { selectFromVisitScheduledDto, visitScheduledDtoModelPrimitives, VisitScheduledDtoModelSelector } from './VisitScheduledDtoModel.base';

/**
 * VisitScheduledDtoModel
 */
export const VisitScheduledDtoModel = VisitScheduledDtoModelBase
  .actions(self => ({
    // This is an auto-generated example action.
    log() {
      console.log(JSON.stringify(self));
    },
  }));
